import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http'; // Updated import
import { AuthGaurdService } from "./service/auth-gaurd.service";
import { AppComponent } from './app.component';
import { StoreModule } from '@ngrx/store'; // Updated import
import { buildingReducer } from './reducers/building.reducers';
import { buildingDetailsReducer } from './reducers/building-details.reducers';
import { memberReducer } from './reducers/team-members.reducers';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { UserPlanService } from './service/userplan.service';
import { HttpService } from './service/http.service';
import { PaymentService } from "./service/payment.service";
import { HeaderComponent } from './component/header/header.component';
import { SidemenuComponent } from './component/sidemenu/sidemenu.component';
import { CommentService } from "./service/comment.service";
import { eventEmitterService } from "./service/eventEmitter.service";
import { EventService } from "./service/event.service";
import { FooterComponent } from './component/footer/footer.component';
import { GroupService } from "./service/group.service";
import { BuildingsService } from "./service/buildings.service";
import { MaintananceService } from './service/maintanance.service';
import { UserService } from "./service/user.service";
import { VoteUpdateService } from "./service/vote-update.service";
import { DocumentService } from "./service/document.service";
import { FeedUpdateServiceService } from "./service/feed-update-service.service";
import { PostFilterService } from "./service/post-filter.service";
import { PercentageIncreaseUpdaterService } from "./service/percentage-increase-updater.service";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TagInputModule } from 'ngx-chips';
import { UserInfoService } from './service/user-info.service';
import { MomentModule } from 'ngx-moment';
import { HomeComponent } from './component/home/home.component';

/**
 * Components for declaration
 */
import { CustomMessageComponent } from './component/custom-message/custom-message.component';
import { LoginComponent } from './component/login/login.component';
import { HomepageComponent } from './component/homepage/homepage.component';
import { SharedModule } from './shared/shared.module';
import { UsersComponent } from './users/users.component';
import { AccountComponent } from './component/account/account.component';
import { PostComponent } from './component/activity-feed/post/post.component';
import { SettingsHeaderComponent } from './component/settings-header/settings-header.component';
import { SettingsComponent } from './component/settings/settings.component';
import { NotificationsComponent } from './component/settings/notifications/notifications.component';
import { MybuildingComponent } from './component/settings/mybuilding/mybuilding.component';
import { MessageComponent } from "./component/message/message.component";
import { ChatComponent } from './component/chat/chat.component';
import { GroupsComponent } from "./component/groups/groups.component";
import { CreategroupComponent } from './component/groups/creategroup/creategroup.component';
import { MessagesHeaderComponent } from './component/messages-header/messages-header.component';
import { AllgroupsComponent } from './component/groups/allgroups/allgroups.component';
import { CommentsComponent } from "./component/activity-feed/post/comments/comments.component";
import { TimeAgoPipe } from "time-ago-pipe";
import { ReplyComponent } from "./component/activity-feed/post/comments/reply/reply.component";
import { RouterResolverService } from "./service/router-resolver.service";
import { AuthServiceAuthenticatedUsersService } from "./service/auth-service-authenticated-users.service";
import { ThankyouComponent } from "./component/thankyou/thankyou.component";
import { ConvertHTMLPipe } from './pipe/convert-html.pipe';
import { AlertsComponent } from "./component/building/alerts/alerts.component";
import { EventsComponent } from './component/events/events.component';
import { ResidentListComponent } from "./component/resident/resident-list/resident-list.component";
import { UserAccountSettingsComponent } from "./component/settings/user-account-settings/user-account-settings.component";
import { CheckboxStatusPipePipe } from './pipe/checkbox-status-pipe.pipe';
import { BuildingsComponent } from './component/building/buildings/buildings.component';
import { userSearchPipe } from "./pipe/userSearchPipe";
import { PaymentSettingsComponent } from './component/settings/payment-settings/payment-settings.component';
import { InviteComponent } from './component/invite/invite.component';
import { DocumentsComponent } from './component/documents/documents.component';
import { PromocodeComponent } from './component/settings/promocode/promocode.component';
import { AttendancePipe } from './pipe/attendance.pipe';
import { MaintenanceCheckPipe } from './pipe/maintenance-check.pipe';
import { AddressPipe } from "./pipe/address.pipe";
import { BaseurlPipe } from './pipe/baseurl.pipe';
import { GroupFilterPipe } from './pipe/group-filter.pipe';
import { ManagerBuildingAddressFormatPipe } from './pipe/manager-building-address-format.pipe';
import { AttendStylePipe } from './pipe/attend-style.pipe';
import { RemoveImagePipe } from './pipe/remove-image.pipe';
import { ClickOutsideDirective } from './directive/click-outside.directive';
import { Meta, Title } from '@angular/platform-browser';
import { CloseDropdownDirective } from './directive/close-dropdown.directive';
import { ImageLoadingComponent } from './component/image-loading/image-loading.component';
import { PostFlagPipe } from './pipe/post-flag.pipe';
import { TruncatePipe } from './pipe/truncate.pipe';
import { nl2brPipe } from "./pipe/nl2brPipe";
import { TwitterContentPipe } from './pipe/twitter-content.pipe';
import { AddressSearchBarComponent } from './component/address-search-bar/address-search-bar.component';
import { ReportToMycoopComponent } from './component/report-to-mycoop/report-to-mycoop.component';
import { PricingComponent } from './component/pricing/pricing.component';
import { ProductComponent } from './component/product/product.component';
import { AddtocalendarComponent } from './component/addtocalendar/addtocalendar.component';
import { CreatebuildingComponent } from './component/createbuilding/createbuilding.component';
import { PromoStatusPipe } from './pipe/promo-status.pipe';
import { ioService } from './service/io.service';
import { CoverPhotoComponent } from './component/activity-feed/cover-photo/cover-photo.component';
import { CustomHttpClientService } from './service/custom-http-client.service';
import { AuthService } from './service/auth.service';
import { ErrorComponent } from './component/error/error.component';
import { UpgradeSuccess } from './component/accountUpgradeSuccess/thankyou.component';
import { UpgradeService } from './service/upgrade.service';
import { ContactUsComponent } from './component/contact-us/contact-us.component';
import { UpgradeModalComponent } from './component/upgrade-modal/upgrade-modal.component';
import { AboutUsComponent } from './component/about-us/about-us.component';
import { RatingComponent } from './component/rating/rating.component';
import { AppRoutingModule } from './app-routing.module';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SidemenuComponent,
    FooterComponent,
    HomeComponent,
    CustomMessageComponent,
    LoginComponent,
    HomepageComponent,
    UsersComponent,
    AccountComponent,
    SettingsHeaderComponent,
    SettingsComponent,
    NotificationsComponent,
    MybuildingComponent,
    MessagesHeaderComponent,
    MessageComponent,
    GroupsComponent,
    CreategroupComponent,
    AllgroupsComponent,
    PostComponent,
    CommentsComponent,
    ReplyComponent,
    TimeAgoPipe,
    ThankyouComponent,
    ConvertHTMLPipe,
    AlertsComponent,
    ResidentListComponent,
    UserAccountSettingsComponent,
    CheckboxStatusPipePipe,
    BuildingsComponent,
    userSearchPipe,
    PaymentSettingsComponent,
    InviteComponent,
    DocumentsComponent,
    PromocodeComponent,
    AttendancePipe,
    MaintenanceCheckPipe,
    AddressPipe,
    BaseurlPipe,
    GroupFilterPipe,
    ManagerBuildingAddressFormatPipe,
    AttendStylePipe,
    RemoveImagePipe,
    ClickOutsideDirective,
    CloseDropdownDirective,
    ImageLoadingComponent,
    PostFlagPipe,
    nl2brPipe,
    TwitterContentPipe,
    AddressSearchBarComponent,
    PricingComponent,
    ReportToMycoopComponent,
    ProductComponent,
    AddtocalendarComponent,
    CreatebuildingComponent,
    ChatComponent,
    EventsComponent,
    PromoStatusPipe,
    CoverPhotoComponent,
    ErrorComponent,
    UpgradeSuccess,
    ContactUsComponent,
    UpgradeModalComponent,
    AboutUsComponent,
    RatingComponent
  ],
  imports: [
    SharedModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule, // Updated import
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    TagInputModule,
    MomentModule,
    StoreModule.forRoot({
      build: buildingReducer,
      buildDetails: buildingDetailsReducer,
      member: memberReducer
    })
  ],
  exports: [
    ChatComponent,
    EventsComponent,
  ],
  providers: [
    UserPlanService,
    CustomHttpClientService,
    HttpService,
    PaymentService,
    CommentService,
    AuthGaurdService,
    RouterResolverService,
    eventEmitterService,
    AuthServiceAuthenticatedUsersService,
    EventService,
    GroupService,
    BuildingsService,
    MaintananceService,
    UserService,
    VoteUpdateService,
    DocumentService,
    FeedUpdateServiceService,
    PercentageIncreaseUpdaterService,
    PostFilterService,
    UserInfoService,
    ioService,
    AuthService,
    UpgradeService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
